/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Impact_TreeInputs */

const en_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You donated ${i?.number} Forest Energy!`)
};

const ar_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`لقد منحت ${i?.number} قوة Forest!`)
};

const de_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast ${i?.number} Forest Power gespendet!`)
};

const es_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡Donaste ${i?.number} poder de tu bosque!`)
};

const fr_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez donné ${i?.number} Pouvoir Forest !`)
};

const it_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai donato ${i?.number} Forest Power!`)
};

const ja_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Forestパワーを贈りました！`)
};

const ko_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Forest Power ${i?.number}을 기부했어요!`)
};

const pt_br_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você doou ${i?.number} Poder do Forest!`)
};

const ru_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы подарили ${i?.number} силу Forest!`)
};

const th_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`คุณส่งมอบพลังแห่ง Forest ไปแล้ว ${i?.number} หน่วย!`)
};

const tr_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Forest Gücü bağışladın!`)
};

const zh_cn_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你成功捐赠了 ${i?.number} 森林能量！`)
};

const zh_tw_earth_day_2025_impact_tree = /** @type {(inputs: Earth_Day_2025_Impact_TreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你成功捐贈了 ${i?.number} 森林能量！`)
};

/**
* | output |
* | --- |
* | "You donated {number} Forest Energy!" |
*
* @param {Earth_Day_2025_Impact_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_impact_tree = /** @type {((inputs: Earth_Day_2025_Impact_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Impact_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_impact_tree(inputs)
	if (locale === "ar") return ar_earth_day_2025_impact_tree(inputs)
	if (locale === "de") return de_earth_day_2025_impact_tree(inputs)
	if (locale === "es") return es_earth_day_2025_impact_tree(inputs)
	if (locale === "fr") return fr_earth_day_2025_impact_tree(inputs)
	if (locale === "it") return it_earth_day_2025_impact_tree(inputs)
	if (locale === "ja") return ja_earth_day_2025_impact_tree(inputs)
	if (locale === "ko") return ko_earth_day_2025_impact_tree(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_impact_tree(inputs)
	if (locale === "ru") return ru_earth_day_2025_impact_tree(inputs)
	if (locale === "th") return th_earth_day_2025_impact_tree(inputs)
	if (locale === "tr") return tr_earth_day_2025_impact_tree(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_impact_tree(inputs)
	return zh_tw_earth_day_2025_impact_tree(inputs)
});